import { createFileRoute, Link, Outlet, useMatches } from '@tanstack/react-router'
import React from 'react'
import { Skeleton } from 'antd'
import { useTranslation } from 'react-i18next'
import { CampaignSettingsShell } from '../campaign/components/settings/campaign-settings-shell'
import { PortaledBreadcrumb } from '../components/portaled-breadcrumb'
import { useSite } from '../site/hooks'
import { SiteHeader } from '../site/components/site-header'

export const Route = createFileRoute('/_auth/_main/websites/$siteId/settings')({
    component: Settings,
})

function Settings() {
    const { siteId } = Route.useParams()
    const { t } = useTranslation()
    const { data: site } = useSite(siteId)
    const matches = useMatches()
    const base = `/websites/${siteId}/settings`

    if (!site) {
        return <Skeleton active />
    }

    // Applying via WhatsApp only matters on websites with vacancies; other websites only get the chat.
    const hasVacancies = (site.vacanciesCount ?? 0) > 0

    const vacancyItems = [
        {
            key: `${base}/vacancies`,
            label: t('Vacancies'),
        },
        {
            key: `${base}/apply-form`,
            label: t('Apply form'),
        },
        {
            key: `${base}/whatsapp`,
            label: t('WhatsApp'),
        },
    ]

    const items = [
        {
            key: base,
            label: t('Assistant'),
        },
        {
            key: `${base}/knowledge`,
            label: t('Knowledge'),
        },
        ...(hasVacancies ? vacancyItems : []),
        {
            key: `${base}/connection`,
            label: t('Connection'),
        },
    ]

    const path = matches[matches.length - 1]?.pathname.replace(/\/$/, '') ?? base
    const activeKey = items.find((item) => item.key === path)?.key ?? base

    return (
        <>
            <PortaledBreadcrumb
                items={[
                    {
                        title: <Link to="/websites">{t('Websites')}</Link>,
                    },
                    {
                        title: (
                            <Link
                                to="/websites/$siteId"
                                params={{ siteId }}
                            >
                                {site.name}
                            </Link>
                        ),
                    },
                    {
                        title: t('Settings'),
                    },
                ]}
            />
            <SiteHeader
                site={site}
                backToChats
            />
            <CampaignSettingsShell
                items={items}
                activeKey={activeKey}
                title={t('Website settings')}
                stickyHeader={false}
            >
                <Outlet />
            </CampaignSettingsShell>
        </>
    )
}
